// extracted by mini-css-extract-plugin
module.exports = {"stats":"styles-module--stats--3DY5H","statLabel":"styles-module--statLabel--1pgzA","statLine":"styles-module--statLine--1DL21","statValue":"styles-module--statValue--2R96S"};